import React, {Component} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import Container from "../../../modules/commons/Container";
import Button from "../../../modules/commons/Button";
import FlexView from "react-flexview";
import MasterVoucherTab from "./components/masterVoucherTab";

class MasterVoucher extends Component {
    contents = [
        {
            title: "Master Voucher",
            component: <MasterVoucherTab
                tab="master"
                menuAccess={this.props.menuAccess}
            />
        },
        {
            title: "User Voucher",
            component: <MasterVoucherTab
                tab="user"
                menuAccess={this.props.menuAccess}
            />
        },
    ];

    render() {
        return (
            <Container>
                <Tabs>
                    <TabList>
                        {this.contents.map((content, index) => (
                            <Tab
                                key={content.title + index}
                                id={`btn_navigate_${content.title}`}
                            >
                                {content.title}
                            </Tab>
                        ))}
                    </TabList>
                    {this.contents.map((content, index) => (
                        <TabPanel key={content.title + index}>{content.component}</TabPanel>
                    ))}
                </Tabs>
            </Container>
        );
    };
}

export default MasterVoucher;